import React from "react";

const Closing = () => {
	return (
		<section className="bg-secondary py-12 px-8">
			<div className="max-w-screen-lg text-left text-white">
				<p className="text-2xl font-bold italic">WE SHIP YOUR GOODS</p>
				<p className="text-2xl font-bold italic">WITHIN 24 HOURS.</p>
				<p className="text-2xl font-bold italic">
					ONLY WE CAN DO THAT.
				</p>
				<p className="text-2xl font-bold italic">WE USE THE FASTEST</p>
				<p className="text-2xl font-bold italic">METHOD AVAILABLE IN</p>
				<p className="text-2xl font-bold italic">THE WORLD TODAY.</p>
			</div>
		</section>
	);
};

export default Closing;
